module.exports = __webpack_public_path__ + "static/2021_map_desktop-dfe3453db1297ee34751ca093b25f07e.jpg";